import gql from 'graphql-tag';

import mainDisplayObjectFragment from './mainDisplayObjectFragment';

export const recentlyViewedMainDisplayObjectFragment = gql`
  fragment recentlyViewedMainDisplayObjectFragment on RecentlyViewedMainDisplayObject {
    dokkioClass
    mainDisplayObject {
      ...mainDisplayObjectFragment
    }
    lastViewedAt
  }
  ${mainDisplayObjectFragment}
`;
export default recentlyViewedMainDisplayObjectFragment;
